import { notification } from "antd";
import { loading } from "../Action/App";
import { post } from "../Utils/httpInterceptor";
import JSZip from "jszip";

export const uploadDocument = (objBody = {}) => async (dispatch) => {
  dispatch(loading(true));

  try {
    const formData = new FormData();

    const file = objBody?.file;

    if (file) {
      const zip = new JSZip();
      zip.file(file.name, file);

      const zipBlob = await zip.generateAsync({ type: "blob" });
      formData.append("file", zipBlob, `${new Date().getTime()}.zip`);
    }

    if (objBody.info) {
      formData.append("info", objBody.info);
    }

    const response = await post(
      "/customerservicing/notification/saveNotificationDetails",
      formData,
      false,
      true
    );

    if (!response.data.error) {
      notification.success({ message: response.data.message });
    } else {
      notification.error({ message: response.data.message });
    }

    return response;
  } catch (err) {
    dispatch(loading(false));
  } finally {
    dispatch(loading(false));
  }
};
